import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { calendarQueryKeys } from "../calendar";
import { eventOccurrenceQueryKeys } from "./eventOccurrenceQueryKeys";

export const useMutationEventOccurrenceLateCancelRsvp = ({
  api,
}: {
  api: ApiType;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ rsvpId }: { rsvpId: number }) =>
      (await api.eventApi.lateCancelRsvp(rsvpId)).data,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: eventOccurrenceQueryKeys.all(),
      });
      await queryClient.invalidateQueries({
        queryKey: calendarQueryKeys.eventOccurrences(),
      });
    },
  });
};
